<template>
  <div>
    <div class="col-md-12" v-show="information.length == 0" style="padding-top:29vh;">
      <div class="loader_page"></div>
    </div>
    <div v-show="information.length != 0">
      <div class="fab">
        <span class="fab-action-button">
          <p style="text-align:center;padding-top:12px;font-size:22px; font-weight:400; color: #fff" v-show="now != 0">{{now}}
          </p>
          <i class="fab-action-button__icon ti-reload" v-show="now == 0"></i>

        </span>
        <ul class="fab-buttons">

          <li class="fab-buttons__item" v-on:click="stopRefresh()" v-show="!refreshButton">
            <a href="#" class="fab-buttons__link" data-tooltip="Zatrzymaj odświerzanie">
              <i class="icon-material icon-material_tw ti-close"></i>
            </a>
          </li>

          <li class="fab-buttons__item" v-on:click="startInterval()" v-show="refreshButton">
            <a href="#" class="fab-buttons__link" data-tooltip="Uruchom odświerzanie">
              <i class="icon-material icon-material_tw ti-control-play"></i>
            </a>
          </li>
        </ul>
      </div>

      <div class="row">


        <div class="col-md-4 ">
          <router-link to="/online" style="color: #212529">
            <div class="card mb-2">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-3 col-xs-2">
                    <img src="../assets/team.svg" alt="people_icon" style="width:100%">

                  </div>
                  <div class="col-md-9 col-xs-10">
                    <h4 class="card-title">Załogi online</h4>
                    <hr>
                    <p class="card-text">
                      {{status.online}} dostępnych...
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </router-link>

        </div>
        <div class="col-md-4">
          <router-link to="/teams/" style="color: #212529">

            <div class="card mb-2">
              <div class="card-body">
                <div class="row">

                  <div class="col-md-3 col-xs-2">
                    <img src="../assets/jeep.svg" alt="people_icon" style="width:100%">

                  </div>
                  <div class="col-md-9 col-xs-10">
                    <h4 class="card-title">Ilość załóg:</h4>
                    <hr>
                    <p class="card-text">
                      {{status.teams}} załóg...
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </router-link>
        </div>
        <div class="col-md-4">
          <router-link to="/issues/" style="color: #212529">

            <div class="card mb-2">
              <div class="card-body">
                <div class="row">

                  <div class="col-md-3 col-xs-2">
                    <img src="../assets/settings.svg" alt="people_icon" style="width:100%">

                  </div>
                  <div class="col-md-9 col-xs-10">
                    <h4 class="card-title">Awarie</h4>
                    <hr>
                    <p class="card-text">
                      {{status.issues}} zgłoszeń
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="row" style="margin-top:10px;">
        <div class="col-md-12">

          <GmapMap :center="race.startPos" :zoom="14" map-type-id="terrain" style="width: 100%; height: 500px" :options="options">
            <GmapMarker :position="race.startPos" :clickable="true" />
            <gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoMaps" @closeclick="infoMaps=false">
              <div>
                <h5 class="card-title">{{infoContent.name}}</h5>
                <p v-if="infoContent.updatedAt != undefined">Aktualizacja: {{infoContent.updatedAt}}</p>
                <router-link :to="'/teams/' + infoContent.id"><a class="btn btn-primary btn-sm" style="color:#fff;">Zobacz załoge</a></router-link>
              </div>

            </gmap-info-window>
            <GmapCluster>
              <GmapMarker v-for="(item, index) in gps" :key="index" :position="item.position" :clickable="true" :icon="item.avatar" @click="toggleInfo(item, index)" />
            </GmapCluster>
            <GmapMarker :position="race.endPos" :clickable="true" />
          </GmapMap>
        </div>

      </div>
      <div class="row" style="margin-top:15px;">
        <div class="col-md-8 ">
          <div class="row label-zl">
            <div class="start">
              <img src="../assets/label.png" class>
            </div>
            <div class="md10">
              <h5>Informacje z rajdu</h5>
            </div>
            <div class="end">
              <img src="../assets/end.png" class>
            </div>
          </div>
          <div class="card mb-2">

            <div class="card-body no_pad">

              <div class="inbox_chat" style="height:800px">
                <div class="chat_list " v-for="(item, index) in posts" :key="index">
                  <div class="chat_people">
                    <div class="chat_img">
                      <router-link :to=" '/teams/' + item.owner._id">
                        <clazy-load :src="url + item.owner.icon">
                          <img :src="url + item.owner.icon">
                          <div class="preloader" slot="placeholder">
                            <div class="loader"></div>
                          </div>
                        </clazy-load>
                      </router-link>
                    </div>
                    <div class="chat_ib">
                      <h5>
                        <router-link :to=" '/teams/' + item.owner._id">
                          {{item.owner.name}}
                        </router-link>
                        <span class="chat_date" v-b-tooltip.hover :title="item.updatedAt | formatDate">{{item.updatedAt | ago}}</span>
                      </h5>
                      <p>{{item.text}}</p>
                      <div class="row" v-if="item.image != null">
                        <clazy-load :src="media + item.image+'.m.jpg'" class="card-img-top col-md-2 col-xs-3">
                          <img :src="media + item.image+'.m.jpg'" class="card-img-top" style="max-width:100%;border-radius:0;" @click="show('gallery', media + item.image + '.jpg')">
                          <div class="preloader" slot="placeholder">
                            <div class="loader"></div>
                          </div>
                        </clazy-load>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="row label-zl">
            <div class="start">
              <img src="../assets/label.png" class>
            </div>
            <div class="md10">
              <h5>Galeria</h5>
            </div>
            <div class="end">
              <img src="../assets/end.png" class>
            </div>
          </div>
          <div class="card mb-2">
            <div class="card-body">

              <div class="row" style="padding-right:15px; padding-left:15px;height:560px; overflow-y:auto">

                <div class="col-md-4 col-xs-3" :key="index" v-for="(item, index) in gallery.slice(0, 100)" style="padding:0;height:80px">
                  <clazy-load :src="media + item.image + '.m.jpg'" class="card-img-top">
                    <img :src="media + item.image + '.m.jpg'" class="card-img-top" style="border-radius:0;height:80px" @click="show('gallery', media + item.image + '.jpg')">
                    <div class="preloader" slot="placeholder" style="padding-top:25px">
                      <div class="loader" style="margin-left:auto;margin-right:auto;"></div>
                    </div>
                  </clazy-load>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <modal name="gallery" :scrollable="true" :adaptive="true" :height="'auto'">

        <div style="overflow-y:auto;height:100%">
          <img :src="info" alt="">
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  import api from '../http/api.js'
  import styleMap from '../maps-style.json'
  import config from '../config.json'




  export default {
    data() {
      return {
        posts: [],
        information: [],
        gps: [],
        refresh: {
          post: false,
          media: false,
          status: false,
          gps: false
        },

        now: 60,
        timer: "",
        infoMaps: true,
        refreshInfo: '',
        refreshButton: false,
        media: config.media,
        gallery: [],
        info: "",
        infoPosition: null,
        infoContent: {
          img: "",
          vehicles: [],
          members: []
        },
        url: config.url,
        status: {
          issues: 0,
          online: 0,
          teams: 0,
          media: 0
        },
        infoOpened: false,
        infoCurrentKey: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        options: {
          styles: styleMap
        },
        race: {
          startPos: {
            lat: 50.265401,
            lng: 19.027222
          },
          endPos: {
            lat: 39.985889,
            lng: 23.98625
          }
        }
      }
    },
    methods: {
      showComments(id) {
        var obj = document.getElementsByClassName(id)
        for (var i = 0; i < obj.length; i++) {
          if (obj[i].style.display == 'block')
            obj[i].style.display = "none"
          else
            obj[i].style.display = "block"
        }
      },
      show(el, data) {
        this.info = data
        switch (el) {
          case 'gallery':
            this.$modal.show('gallery');

            break;
        }
      },
      hide(el) {
        switch (el) {
          case 'gallery':
            this.$modal.hide('gallery');
            break;

        }
      },
      showModal(data) {
        this.$swal(data)
      },
      getPosition: function(marker) {
        return {
          lat: parseFloat(marker.lat),
          lng: parseFloat(marker.lng)
        }
      },
      toggleInfo: function(marker, key) {
        this.infoMaps = true
        this.infoPosition = this.getPosition(marker.position);
        this.infoContent = marker;
        if (this.infoCurrentKey == key) {
          this.infoOpened = !this.infoOpened;
        } else {
          this.infoOpened = true;
          this.infoCurrentKey = key;
        }
      },
      getMedia() {
        var vm = this
        api.getMediaAction()
          .then(function(media) {
            if (vm.gallery.length == 0)
              vm.gallery = media.data;
            else if (vm.gallery.length != media.data.length) {
              for (var i = vm.gallery.length; i < media.data.length; i++) {
                vm.gallery.unshift(media.data[i - vm.gallery.length])
              }
              vm.refresh.media = true
            } else {
              vm.refresh.media = true
            }
          })
          .catch(error => {
            vm.$swal('Ups... coś poszło nie tak',
              `${error}`,
              'warning'
            )
          })
      },
      getStatus() {
        var vm = this
        api.getStatusAction()
          .then(function(res) {
            vm.status = res.data
            vm.refresh.status = true
          })
          .catch(error => {
            vm.$swal('Ups... coś poszło nie tak',
              `${error}`,
              'warning'
            )
          })
      },

      getPost() {
        var vm = this

        api.getPostsAction()
          .then(function(posts) {
            if (vm.posts.length == 0) {
              vm.posts = posts.data;
              vm.refresh.post = true
            } else {
              vm.refresh.post = true
            }
          })
          .catch(error => {
            vm.$swal('Ups... coś poszło nie tak',
              `${error}`,
              'warning'
            )
          })
      },
      getGps() {
        var vm = this
        api.getGpsAction()
          .then(function(teams) {
            var tmp = ""
            var i = 0
            if (vm.gps.length == 0) {
              for (i = 0; i < teams.data.length; i++) {

                if (teams.data[i].team.icon != undefined)
                  tmp = config.url + teams.data[i].team.icon
                else
                  tmp = ""

                var loc = {
                  id: teams.data[i].team._id,
                  position: {
                    lng: teams.data[i].gps.coordinates[0],
                    lat: teams.data[i].gps.coordinates[1]
                  },
                  name: teams.data[i].team.name,
                  avatar: tmp,
                  img: teams.data[i].team.img,
                  vehicle: teams.data[i].vehicle,
                  members: teams.data[i].team.members
                }

                vm.gps.push(loc)
              }
            } else {
              for (i = 0; i < teams.data.length; i++) {
                for (var j = 0; j < vm.gps.length; j++) {
                  if (vm.gps[j].id == teams.data[i].team._id) {
                    vm.gps[j].position = {
                      lng: teams.data[i].gps.coordinates[0],
                      lat: teams.data[i].gps.coordinates[1]
                    }
                  }
                }
              }
              vm.refresh.gps = true
            }
          })
          .catch(error => {
            vm.$swal('Ups... coś poszło nie tak',
              `${error}`,
              'warning'
            )
          })
      },

      getMain() {
        var vm = this
        api.getMainAction()
          .then(function(res) {

            vm.information = res
            vm.race = {
              startPos: {
                lat: parseFloat(res.data.start.coordinates[1]),
                lng: parseFloat(res.data.start.lng)
              },
              endPos: {
                lat: parseFloat(res.data.finish.lat),
                lng: parseFloat(res.data.finish.lng)
              }
            }
          })
          .catch(error => {
            vm.$swal('Ups... coś poszło nie tak',
              `${error}`,
              'warning'
            )
          })
      },

      startGetData() {
        this.getPost()
        this.getGps()
        this.getStatus()
        this.getMedia()
        var vm = this

        this.refreshInfo = setInterval(() => {
          if (vm.refresh.post && vm.refresh.media && vm.refresh.status && vm.refresh.gps) {
            vm.now = 60
            vm.startInterval()
            clearInterval(vm.refreshInfo)
          }
        }, 1000)
      },

      startInterval() {
        this.refreshButton = false
        var vm = this
        this.timer = setInterval(() => {
          vm.now -= 1
          if (vm.now <= 0) {
            vm.refresh = {
              post: false,
              media: false,
              status: false,
              gps: false
            }
            clearInterval(this.timer)
            vm.startGetData()
          }
        }, 1000)
      },
      stopRefresh() {
        this.refreshButton = true
        clearInterval(this.timer)
      }

    },
    mounted() {
      this.getMain()
      this.getPost()
      this.getGps() //refresh: ok
      this.getStatus()
      this.getMedia()
    },
    created() {
      this.startInterval()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>
<style>
  .chat_img {
    text-align: center;
  }

  .no_pad {
    padding: 0px;
  }
</style>
